import { createContext, useContext, useEffect, useState, ReactNode } from "react";
import * as faceapi from "face-api.js"

interface FaceApiValue {
    modelsLoaded: boolean;
    loadingProgress: number;
    loadingError: string | null;
}

const FaceApiContext = createContext<FaceApiValue>({
    modelsLoaded: false,
    loadingProgress: 0,
    loadingError: null,
});

export function useFaceApi(){
    return useContext(FaceApiContext)
}

const MODEL_URL="/models";

const MODELS_TO_LOAD = [
    {name: "TinyFaceDetector", load: () => faceapi.nets.tinyFaceDetector.loadFromUri(MODEL_URL) },
    //in case of more models needed, they could be added here
];

export function FaceApiProvider({ children }: {children: ReactNode}) {
    const[modelsLoaded, setModelsLoaded] = useState(false);
    const[loadingProgress, setLoadingProgress] = useState(0);
    const[loadingError, setLoadingError] = useState<string|null>(null);

    useEffect(() => {
        let cancelled = false;
        
        async function loadAll(){
            try{
                for(let i = 0; i < MODELS_TO_LOAD.length; i++){
                    await MODELS_TO_LOAD[i].load();
                    if (cancelled) return;
                    setLoadingProgress(Math.round(((i + 1) / MODELS_TO_LOAD.length) * 100));
                }
                if(!cancelled) setModelsLoaded(true);
            } catch (err) {
                if(!cancelled) {
                    setLoadingError(err instanceof Error ? err.message : "Unknown Error occured while loading models")
                }
            }
        }

        loadAll();
        return () => {
            cancelled = true;
        };
    }, []);

    return (
        <FaceApiContext.Provider value={{ modelsLoaded, loadingProgress, loadingError}}>
            {children}
        </FaceApiContext.Provider>
    );
}